<template>
  <div>
    <!-- no-close-on-backdrop
      no-close-on-esc -->
    <b-modal
      ref="modal-detail-attendance"
      :title="$t('PERSONAL ATTENDANCE')"
      modal-class="modal-primary"
      hide-footer
      @hidden="$emit('hideModal')"
      size="md"
    >
      <div class="">
        <div class="d-flex">
          <tabler-icon icon="UserIcon" class="text-primary" size="17" />
          <h5 style="margin-left: 5px">{{ $t("Employee") }} :</h5>
          <span style="margin-left: 5px"> {{ employeeName }} </span>
        </div>

        <div v-if="attendance.es_vacacion" class="d-flex">
          <tabler-icon icon="CalendarIcon" class="text-primary" size="17" />
          <h5 style="margin-left: 5px">Vacacion :</h5>
          <span
            style="margin-left: 5px"
            :class="`text-${
              attendance.es_vacacion_comprada ? 'success' : 'danger'
            }`"
          >
            {{ attendance.es_vacacion_comprada ? "Comprada" : "No comprada" }}
          </span>
        </div>

        <div class="d-flex align-items-center justify-content-between">
          <h4 class="mt-1">{{ $t("Attendance") }}</h4>
          <template v-if="attendance.es_vacacion != 1">
            <feather-icon
              v-if="
                (attendance.checking == null && attendance.checkout == null) ||
                (attendance.checking != null && attendance.checkout == null)
              "
              icon="CheckIcon"
              class="text-success mt-1 cursor-pointer"
              size="20"
              v-b-tooltip.hover.bottom="$t('Create Manual Attendance')"
              @click="openCreateManualAttendanceModal()"
            />
          </template>
        </div>

        <b-card :bg-variant="isDarkSkin ? 'dark' : 'light'">
          <div class="d-flex" style="margin-top: 5px">
            <tabler-icon
              icon="CalendarMinusIcon"
              class="text-primary"
              size="17"
            />
            <h5 style="margin-left: 5px; width: 60px">{{ $t("Date") }}</h5>
            :
            <span class="ml-1"> {{ attendance.date | myGlobal }} </span>
          </div>

          <div class="d-flex" style="margin-top: 5px">
            <tabler-icon
              icon="CalendarMinusIcon"
              class="text-primary"
              size="17"
            />
            <h5 style="margin-left: 5px; width: 60px">{{ $t("Day") }}</h5>
            :
            <span class="ml-1 text-uppercase">
              {{ $t(getDayName(attendance.date)) }}
            </span>
          </div>

          <div class="d-flex" style="margin-top: 5px">
            <tabler-icon icon="ClockIcon" class="text-success" size="17" />
            <h5 style="margin-left: 5px; width: 60px">{{ $t("Checking") }}</h5>
            :
            <b-badge
              :variant="
                attendance.checking != null ? 'light-success' : 'light-danger'
              "
              class="ml-1"
            >
              <span>
                {{
                  attendance.checking != null
                    ? attendance.checking
                    : $t("Not mark")
                }}
              </span>
            </b-badge>

            <!-- ENLACE UBICACIÓN DE ENTRADA -->
            <a
              v-if="attendance.in_lat && attendance.in_lng"
              :href="`https://www.google.com/maps?q=${attendance.in_lat},${attendance.in_lng}`"
              target="_blank"
              class="ml-2 text-primary"
            >
              📍 Entrada
            </a>

            <b-badge
              v-if="attendance.is_late == 1"
              variant="light-danger"
              class="ml-2"
            >
              <span> {{ $t("Late") }} </span>
            </b-badge>
          </div>

          <div class="d-flex" style="margin-top: 5px">
            <tabler-icon icon="ClockIcon" class="text-success" size="17" />
            <h5 style="margin-left: 5px; width: 60px">{{ $t("Check out") }}</h5>
            :
            <b-badge
              :variant="
                attendance.checkout != null ? 'light-success' : 'light-danger'
              "
              class="ml-1"
            >
              <span>
                {{
                  attendance.checkout != null
                    ? attendance.checkout
                    : $t("Not mark")
                }}
              </span>
            </b-badge>

            <!-- ENLACE UBICACIÓN DE ENTRADA -->
            <a
              v-if="attendance.out_lat && attendance.out_lng"
              :href="`https://www.google.com/maps?q=${attendance.out_lat},${attendance.out_lng}`"
              target="_blank"
              class="ml-2 text-primary"
            >
              📍 Salida
            </a>
          </div>
        </b-card>

        <h4 class="mt-2">{{ $t("Justification") }}</h4>

        <b-card
          v-if="justification.justification_id != null"
          :bg-variant="isDarkSkin ? 'dark' : 'light'"
        >
          <b-row class="mt-1">
            <b-col cols="4" md="4" lg="4" xl="4" class="text-left">
              <tabler-icon
                icon="CalendarMinusIcon"
                class="text-primary"
                size="17"
              />
              <span>
                {{ $t("Date") }}
              </span>
            </b-col>
            <b-col cols="8" md="8" lg="8" xl="8" class="text-left">
              <span> {{ justification.date | myGlobal }} </span>
            </b-col>
          </b-row>

          <b-row class="mt-1">
            <b-col cols="4" md="4" lg="4" xl="4" class="text-left">
              <tabler-icon
                icon="AlertCircleIcon"
                class="text-primary"
                size="17"
              />
              <span>
                {{ $t("Type") }}
              </span>
            </b-col>
            <b-col cols="8" md="8" lg="8" xl="8" class="text-left">
              <span>
                {{ $t(justification.justification_type).toUpperCase() }}</span
              >
            </b-col>
          </b-row>

          <b-row class="mt-1">
            <b-col cols="4" md="4" lg="4" xl="4" class="text-left">
              <tabler-icon icon="UserIcon" class="text-success" size="17" />
              <span>
                {{ $t("Created By") }}
              </span>
            </b-col>
            <b-col cols="8" md="8" lg="8" xl="8" class="text-left">
              <span>{{ justification.user_name }}</span>
            </b-col>
          </b-row>

          <b-row class="mt-1">
            <b-col cols="4" md="4" lg="4" xl="4">
              <tabler-icon
                icon="CalendarMinusIcon"
                class="text-success"
                size="17"
              />
              <span>
                {{ $t("Created at") }}
              </span>
            </b-col>
            <b-col cols="8" md="8" lg="8" xl="8" class="text-left">
              <span>{{ justification.created_at | myGlobalWithHour }}</span>
            </b-col>
          </b-row>

          <b-row class="mt-1">
            <b-col cols="4" md="4" lg="4" xl="4">
              <tabler-icon icon="LoaderIcon" class="text-success" size="17" />
              <span>
                {{ $t("Status") }}
              </span>
            </b-col>
            <b-col cols="8" md="8" lg="8" xl="8" class="text-left">
              <b-badge
                :variant="
                  justification.status_id == 1
                    ? 'light-warning'
                    : 'light-success'
                "
              >
                <span>{{ $t(justification.status) }}</span>
              </b-badge>
            </b-col>
          </b-row>

          <b-row class="mt-1" v-if="justification.url_file != null">
            <b-col cols="4" md="4" lg="4" xl="4">
              <tabler-icon
                icon="FileDescriptionIcon"
                size="17"
                class="d-inline-block text-success"
              />
              <span>
                {{ $t("File") }}
              </span>
            </b-col>
            <b-col cols="8" md="8" lg="8" xl="8" class="text-left">
              <FileBadge
                :file="{
                  name: justification.filename,
                  extension: justification.file_ext,
                  size: justification.file_size,
                  url: justification.url_file,
                }"
                downloadable
              />
            </b-col>
          </b-row>

          <b-row class="mt-1">
            <b-col cols="4" md="4" lg="4" xl="4">
              <tabler-icon
                icon="MessageIcon"
                size="17"
                class="d-inline-block text-success"
              />
              <span>
                {{ $t("Observation") }}
              </span>
            </b-col>
            <b-col cols="8" md="8" lg="8" xl="8" class="text-left">
              <span>{{ justification.observation }}</span>
            </b-col>
          </b-row>
        </b-card>
        <b-card v-else :bg-variant="isDarkSkin ? 'dark' : 'light'" class="mt-1">
          <div class="d-flex justify-content-center align-items-center">
            <h4>{{ $t("No justification found") }}</h4>
          </div>
        </b-card>
      </div>
    </b-modal>

    <ModalCreateManualAttendance
      v-if="showCreateManualAttendanceModal"
      :attendanceData="attendanceData"
      @hidden="showCreateManualAttendanceModal = false"
      @stored="storedEvent"
    />
  </div>
</template>

<script>
import modalMixin from "@/mixins/modal";
import AttendanceService from "@/views/rrhh/views/attendance/services/attendance.service.js";
import FileBadge from "@/views/commons/utilities/FileBadge.vue";
import ModalCreateManualAttendance from "@/views/commons/employee_attendance/justifications/modals/ModalCreateManualAttendance.vue";
import { getDayName } from "@/helpers/helpers.js";
export default {
  mixins: [modalMixin],
  components: {
    FileBadge,
    ModalCreateManualAttendance,
  },
  props: {
    markId: {
      required: true,
    },
    employeeId: {
      required: true,
    },
    date: {
      required: true,
    },
    employeeName: {
      required: true,
    },
  },
  data() {
    return {
      showCreateManualAttendanceModal: false,
      attendanceData: {},
      justification: {
        date: null,
        status: null,
        status_id: null,
        user_id: null,
        url_file: null,
        user_name: null,
        created_at: null,
        observation: null,
        justification_id: null,
        justification_type: null,
        justification_type_id: null,
      },
      attendance: {
        id: null,
        date: null,
        day_id: null,
        status: null,
        is_late: null,
        checking: null,
        checkout: null,
        day_name: null,
        created_at: null,
        finish_break: null,
        begining_break: null,
        day_abbreviation: null,
        es_vacacion: null,
        es_vacacion_comprada: null,
      },
    };
  },
  async created() {
    try {
      this.attendance.date = this.date;
      this.addPreloader();
      await Promise.all([this.getMarkData()]);
    } catch (error) {
      console.log(error);
    } finally {
      this.removePreloader();
    }
  },
  mounted() {
    this.toggleModal("modal-detail-attendance");
  },
  methods: {
    //helpers
    getDayName,
    storedEvent() {
      // this.showModalJustificationAttendance = false;
      // this.selectedAll = false;
      // this.itemsSelected = [];
      // this.getEmployeeJustification();
      this.showCreateManualAttendanceModal = false;
      this.$emit("stored");
    },

    openCreateManualAttendanceModal() {
      this.showCreateManualAttendanceModal = true;
      this.attendanceData.date = this.attendance.date;
      this.attendanceData.personal_id = this.employeeId;
      this.attendanceData.start = this.attendance.checking;
    },

    async getMarkData() {
      try {
        const params = {
          start_date: this.date,
          employee_id: this.employeeId,
          mark_id: this.markId,
        };
        const { data } = await AttendanceService.getJustificationByDate(params);

        if (data.attendances.length) {
          this.attendance.id = data.attendances[0].id;
          this.attendance.day_id = data.attendances[0].day_id;
          this.attendance.status = data.attendances[0].status;
          this.attendance.checking = data.attendances[0].checking;
          this.attendance.begining_break = data.attendances[0].begining_break;
          this.attendance.finish_break = data.attendances[0].finish_break;
          this.attendance.checkout = data.attendances[0].checkout;
          this.attendance.is_late = data.attendances[0].is_late;
          this.attendance.day_name = data.attendances[0].day_name;
          this.attendance.day_abbreviation =
            data.attendances[0].day_abbreviation;
          this.attendance.created_at = data.attendances[0].created_at;
          this.attendance.es_vacacion = data.attendances[0].es_vacacion;
          this.attendance.es_vacacion_comprada =
            data.attendances[0].es_vacacion_comprada;
          this.attendance.in_lat = data.attendances[0].in_lat;
          this.attendance.in_lng = data.attendances[0].in_lng;
          this.attendance.out_lat = data.attendances[0].out_lat;
          this.attendance.out_lng = data.attendances[0].out_lng;
        }

        if (data.justifications.length) {
          this.justification.date = data.justifications[0].date;
          this.justification.status = data.justifications[0].status;
          this.justification.status_id = data.justifications[0].status_id;
          this.justification.user_id = data.justifications[0].user_id;
          this.justification.url_file = data.justifications[0].url_file;
          this.justification.user_name = data.justifications[0].user_name;
          this.justification.created_at = data.justifications[0].created_at;
          this.justification.observation = data.justifications[0].observation;
          this.justification.justification_id =
            data.justifications[0].justification_id;
          this.justification.justification_type =
            data.justifications[0].justification_type;
          this.justification.justification_type_id =
            data.justifications[0].justification_type_id;
          this.justification.filename = data.justifications[0].filename;
          this.justification.file_ext = data.justifications[0].file_ext;
          this.justification.file_size = data.justifications[0].file_size;
        }
      } catch (error) {
        throw error;
      }
    },

    resolveValueAttendance(status) {
      let val = "";
      switch (status) {
        case 1:
          val = "Attend"; //attend
          break;
        case 2:
          val = "Not Work"; //not work
          break;
        case 3:
          val = "Remote"; //remote
          break;
        case 4:
          // val = check == "in" ? day.start : day.end;
          val = "Without schedule"; //without schedule
          break;
        case 5:
          val = "Not Mark"; //not mark
          break;
        case 6:
          // val = check == "in" ? day.start : day.end;
          val = "Justified"; //Justified
          break;
        case 7:
          val = "Rejected"; //Rejected
          break;
        case 8:
          val = "Pending"; //Pending
          break;
        default:
          break;
      }
      return val;
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-flatpicker.scss";

.ml-05 {
  margin-left: 0.5rem;
}
</style>